import type { MvaRow } from "@/hooks/useMvas";

export type MvaState = { kind: "open"; row: MvaRow } | { kind: "delivered"; row: MvaRow } | { kind: "none" };

/** The open MVA if there is one (at most one per company), else the most recent delivery. */
export function mvaForCompany(companyId: string, open: MvaRow[], delivered: MvaRow[]): MvaState {
  const o = open.find((m) => m.companyId === companyId);
  if (o) return { kind: "open", row: o };
  const d = delivered
    .filter((m) => m.companyId === companyId)
    .sort((a, b) => ((a.deliveredAt ?? "") < (b.deliveredAt ?? "") ? 1 : -1))[0];
  return d ? { kind: "delivered", row: d } : { kind: "none" };
}
